import ErrorDisplay from "@/components/ErrorDisplay.vue";

export default {
    components: {
        ErrorDisplay,
    },
    methods: {
        displayMessage(type) {
            if (type == 'uncompleteInput') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Input tipe mandatori ada yang belum terisi... !"
                });
            } else if (type == 'error') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Sistem mengalami gangguan, silahkan hubungi administrator!"
                });
            } else if (type == 'error-getdetil') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Tidak dapat menampilkan Manifest, silahkan hubungi administrator!"
                });
            } else if (type == 'error-connection') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Mohon cek koneksi anda atau hubungi administrator!"
                });
            } else if (type == 'error-connection-refused') {
                this.$notification.error({
                    message: "Error Connection",
                    description:
                        "Koneksi terputus, Mohon cek koneksi anda!"
                });
            } else if (type == 'error-aktif-project') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Tidak dapat menampilkan Proyek aktif, mohon hubungi administrator!"
                });
            } else if (type == 'error-saldo') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Saldo tidak cukup!"
                });
            } else if (type == 'error-emptyDoc') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Keterangan dokumen tidak boleh kosong!"
                });
            } else if (type == 'error-emptyDocTemplate') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Tidak dapat men-download file, Mohon cek koneksi anda!"
                });
            } else if (type == 'error-emptyDocFunction') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Fungsi dokumen tidak boleh kosong!"
                });
            } else if (type == 'error-formatXls') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "File yang dipilih harus berformat .xls/.xlsx!"
                });
            } else if (type == 'error-saldopp') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Permintaan anda melebihi Saldo PP!"
                });
            } else if (type == 'error-ppproyek') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Pastikan PP sesuai dengan kategori proyek!"
                });
            } else if (type == 'error-delete-existing') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Gagal untuk menghapus data, mohon hubungi administrator!"
                });
            } else if (type == 'error-active-pp') {
                this.$notification.error({
                    message: "Error",
                    description:
                        "Tidak ada PP aktif, pastikan anda mempunyai PP aktif!"
                });
            } else if (type == 'error-upload') {
                this.$notification.error({
                    message: "Error Message",
                    description:
                        "Upload gagal, mohon hubungi administrator!"
                });
            } else if (type == 'wrong-password') {
                this.$notification.error({
                    message: "Wrong Password",
                    description:
                        "Mohon cek password anda!"
                });
            } else if (type == '404') {
                this.$notification.error({
                    message: "Error 404",
                    description:
                        "Gangguan sistem, Mohon hubungi Administrator!"
                });
            } else if (type == 'success') {
                this.$notification.success({
                    message: "Successful",
                    description:
                        "Data telah diproses!"
                });
            } else if (type == 'success-save') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah sukses disimpan!"
                });
            } else if (type == 'success-edit') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah sukses diubah!"
                });
            } else if (type == 'success-add') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah ditambahkan!"
                });
            } else if (type == 'success-upload') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah berhasil di-upload!"
                });
            } else if (type == 'success-save') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah berhasil disimpan!"
                });
            } else if (type == 'success-send') {
                this.$notification.success({
                    message: "Success",
                    description:
                        "Data telah sukses dikirim!"
                });
            } else if (type == 'form-warning') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Mohon lengkapi Form yang wajib diisi!"
                });
            } else if (type == 'format-wa-error') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Format nomor Whatsapp tidak sesuai!"
                });
            } else if (type == 'data-exist') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Data telah ada, Silahkan pilih yang lain!"
                });
            } else if (type == 'more-content') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Silahkan tambah beberapa data!"
                });
            } else if (type == 'large-file') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "File terlalu besar!"
                });
            } else if (type == 'no-active-sppd') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Tidak ada No SPPD/S aktif!"
                });
            } else if (type == 'no-detil-klaimsppd') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Tidak ada detil pemakaian PP, silahkan tambah data!"
                });
            } else if (type == 'choose-action') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Mohon pilih aksi!"
                });
            } else if (type == 'denied-manifest') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "akses terbatas untuk Manifest, anda tidak mempunyai hak akses!"
                });
            } else if (type == 'noPICBOD') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Transaksi ini tidak mempunyai PIC dan BOD, mohon hubungi administrator!"
                });
            } else if (type == 'form-duplicate') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Data telah ada, Mohon ganti data anda!"
                });
            } else if (type == 'form-duplicate-contract') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "File kontrak telah ada, hapus terlebih dahulu sebelum diganti dengan yang lain!"
                });
            } else if (type == 'form-duplicate-contract') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "File kontrak telah ada, hapus terlebih dahulu sebelum diganti dengan yang lain!"
                });
            } else if (type == 'form-moreData') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "Tambahkan data minimal satu data!"
                });
            } else if (type == 'form-BOD') {
                this.$notification.warning({
                    message: "Warning",
                    description:
                        "BOD tidak boleh sama dengan PimPro!"
                });
            } else if (type == 'error-only-number') {
                this.$notification.warning({
                    message: "Error Message",
                    description:
                        "Hanya boleh input data tipe 'Number'!"
                });
            } else if (type == 'empty-db') {
                this.$notification.info({
                    message: "Information",
                    description:
                        "Database Kosong, Silahkan buat baru!"
                });
            } else if (type == 'choose-again') {
                this.$notification.info({
                    message: "Information",
                    description:
                        "Kembali pilih data yang kamu butuhkan!"
                });
            } else if (type == 'maxPhone') {
                this.$notification.warning({
                    message: "Error",
                    description:
                        "Whatsapp number exceeds the maximum limit (12 digits)"
                });
            }
        },
        confirmMessage(type) {
            if (type === "confirm-save") {
                this.$confirm({
                    title: "Apakah anda yakin untuk simpan data ini?",
                    content: '',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageReturn", true);
                    },
                    onCancel() { },
                });
            } else if (type === "confirm-save-draft") {
                this.$confirm({
                    title: "Apakah anda yakin untuk simpan data ini sebagai Draft?",
                    content: '',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageReturn", true);
                    },
                    onCancel() { },
                });
            } else if (type === "confirm-edit") {
                this.$confirm({
                    title: "Apakah anda yakin untuk mengubah data ini?",
                    content: '',
                    okText: 'Ya',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageEdit", true);
                    },
                    onCancel() { },
                });
            } else if (type === "confirm-delete") {
                this.$confirm({
                    title: "Apakah anda yakin untuk menghapus data ini?",
                    content: '',
                    okText: 'Ya',
                    okType: 'danger',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageDelete", true);
                    },
                    onCancel() { },
                });
            } else if (type === "confirm-close") {
                this.$confirm({
                    title: "Apakah anda yakin untuk menonaktifkan Proyek ini?",
                    content: '',
                    okText: 'Ya',
                    okType: 'danger',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageClose", true);
                    },
                    onCancel() { },
                });
            }
        },
        displayMessageValue(type, value) {
            if (type == 'pp-notenough') {
                this.$notification.error({
                    message: "Error Message",
                    description:
                        "Saldo PP tidak cukup! kurang " + value
                });
            } else if (type == 'error-nothave-umpd') {
                let descriptions = "";
                if (value.toLowerCase() == 'tidak memiliki no um pd') {
                    descriptions = "Tidak ada UM PD aktif!";
                }
                this.$notification.error({
                    message: "Error Message",
                    description: descriptions
                });
            } else if (type == 'error-notif-umpp') {
                let descriptions = "Please Contact Administrator!";
                if (value.toLowerCase() == 'user tidak memiliki no um pp') {
                    descriptions = "Tidak ada UM PP aktif!";
                }
                this.$notification.error({
                    message: "Error Message",
                    description: descriptions
                });
            } else if (type == 'error-notif-kaskecil') {
                let descriptions = "Please Contact Administrator!";
                if (value == 'Tidak Memiliki Detil Pemakaian') {
                    descriptions = "Tidak ada detil penggunaan, tambahkan terlebih dahulu!";
                }
                this.$notification.error({
                    message: "Error Message",
                    description: descriptions
                });
            } else if (type == 'success-basic') {
                this.$notification.success({
                    message: "Success Message",
                    description: value,
                });
            } else if (type == 'error-basic') {
                this.$notification.error({
                    message: "Error Message",
                    description: value,
                });
            } else if (type == 'error-other') {
                this.$notification.error({
                    message: "Error Message",
                    description: <ErrorDisplay valueError={value} />,
                });
            } else if (type == 'info-basic') {
                this.$notification.info({
                    message: "Information",
                    description: value,
                });
            } else if (type == 'warning-basic') {
                this.$notification.warning({
                    message: "Information",
                    description: value,
                });
            }
        },
        confirmMessageValue(type, value) {
            if (type == 'confirm-delete') {
                this.$confirm({
                    title: "Apakah anda yakin untuk menghapus data ini?",
                    content: '',
                    okText: 'Ya',
                    okType: 'danger',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageDelete", value);
                    },
                    onCancel() { },
                });
            } else if (type == 'confirm-delete-detil') {
                this.$confirm({
                    title: "Apakah anda yakin untuk menghapus data detil ini?",
                    content: '',
                    okText: 'Ya',
                    okType: 'danger',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageDeleteDetil", value);
                    },
                    onCancel() { },
                });
            } else if (type == 'confirm-save') {
                this.$confirm({
                    title: "Apakah anda yakin untuk menyimpan data ini?",
                    content: '',
                    okText: 'Ya',
                    okType: 'danger',
                    cancelText: 'Tidak',
                    onOk() {
                        Event.$emit("confirmMessageSave", value);
                    },
                    onCancel() { },
                });
            }
        }
    },
}
